import React from "react";

interface UserIconProps {
  className?: string;
  size?: number;
}

export const UserIcon: React.FC<UserIconProps> = ({
  className = "",
  size = 28,
}) => {
  return (
    <svg
      width={size}
      height={size}
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.90158 12.7298C7.58963 12.1042 7.42557 11.4102 7.42557 10.6907C7.42557 9.46891 7.90065 8.32024 8.76526 7.45633C9.10862 7.11297 9.49721 6.83102 9.91721 6.61586C9.75948 6.2957 9.54901 5.99969 9.28885 5.73977C8.66588 5.1168 7.83783 4.77344 6.95588 4.77344C6.07393 4.77344 5.24682 5.11656 4.62385 5.73977C4.00088 6.36297 3.65752 7.19125 3.65752 8.0725C3.65752 8.95375 4.00088 9.78203 4.62385 10.405C4.66487 10.4465 4.70799 10.4866 4.75135 10.5257C4.49448 10.6295 4.2451 10.7509 4.00416 10.8909C3.13838 11.395 2.41065 12.1169 1.89994 12.9787C1.45627 13.7263 1.44971 14.6256 1.8826 15.3841C2.31877 16.1505 3.10463 16.608 3.98471 16.608H5.33424C5.36776 16.0345 5.53721 15.467 5.84588 14.947C6.36526 14.0704 7.07026 13.3127 7.90135 12.7298H7.90158Z"
        fill="#1267B5"
      />
      <path
        d="M22.1009 12.9773C21.5902 12.1155 20.8624 11.3936 19.9966 10.8895C19.7569 10.7495 19.5066 10.6279 19.2506 10.5241C19.2937 10.4852 19.3359 10.4451 19.3781 10.4034C20.6639 9.11711 20.6639 7.02414 19.3781 5.73812C18.0912 4.45187 15.9989 4.45187 14.7122 5.73812C14.4499 6.00133 14.2416 6.29805 14.0859 6.61492C14.5048 6.83008 14.8936 7.1118 15.2367 7.45492C16.1004 8.31883 16.5764 9.4675 16.5764 10.6891C16.5764 11.4086 16.4112 12.1026 16.0992 12.7281C16.9315 13.3113 17.6355 14.069 18.1547 14.9455C18.4634 15.4654 18.633 16.033 18.6663 16.6063H20.0159C20.8957 16.6063 21.6818 16.1488 22.1189 15.3827C22.5509 14.6242 22.5443 13.7249 22.1006 12.9773H22.1009Z"
        fill="#1267B5"
      />
      <path
        d="M14.9554 13.508C14.7147 13.3681 14.4653 13.2467 14.2082 13.1429C14.2514 13.1038 14.2945 13.0637 14.3357 13.0222C14.9587 12.399 15.3021 11.5707 15.3021 10.6895C15.3021 9.8082 14.9587 8.97992 14.3357 8.35695C13.7128 7.73398 12.8847 7.39062 12.0037 7.39062C11.1227 7.39062 10.2937 7.73375 9.67072 8.35695C9.04776 8.98016 8.7044 9.80844 8.7044 10.6895C8.7044 11.5705 9.04776 12.3992 9.67072 13.0222C9.71174 13.0637 9.75487 13.1038 9.79822 13.1429C9.54135 13.2467 9.29197 13.3681 9.05104 13.508C8.18526 14.0122 7.45752 14.7341 6.94682 15.5959C6.50315 16.3435 6.49658 17.2428 6.92948 18.0013C7.36565 18.7677 8.15151 19.2252 9.03158 19.2252H14.9749C15.8547 19.2252 16.6408 18.7677 17.077 18.0013C17.5099 17.2428 17.5024 16.3435 17.0596 15.5959C16.5489 14.7341 15.8214 14.0122 14.9554 13.5078V13.508Z"
        fill="white"
        stroke="#1267B5"
      />
    </svg>
  );
};
